import Http from "./http";

export const addProductAPI = (data, options) => {
  return Http.post("admin/product/addProduct", data, options);
};
